<template>
	<div>
		<HeadIndex></HeadIndex>
		<el-row>
			<!-- <el-col :span="22" :offset="1">
				<div class="Page_heading">
					<el-page-header title="首页" :icon="House">
						<template #content>
							<span class="text-large font-600 mr-3"> 用户中心 </span>
						</template>
					</el-page-header>
				</div>
			</el-col> -->
			<el-col :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 22, offset: 1}" :lg="{span: 22, offset: 1}" :xl="{span: 18, offset: 3}" class="custom-col-20 offset-col-2">
				<el-row>
					<el-col :span="24" v-if="activeName=='userinfo'">
						<div class="user_content">
							<el-tabs v-model="activeName1" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="用户信息" name="userinfo">
									<!-- <userinfo ref="userinfo"></userinfo> 20250711改版，之前页面先保留-->
									<personal ref="userinfo"></personal>
								</el-tab-pane>
								<!-- <el-tab-pane label="收货地址" name="addr">
									<addr ref="addr"></addr>
								</el-tab-pane> -->
								<el-tab-pane label="帮手管理" name="helper">
									<helper ref="helper"></helper>
								</el-tab-pane>
								<!-- <el-tab-pane label="品牌关注" name="brand">
									<brand ref="brand"></brand>
								</el-tab-pane>
								<el-tab-pane label="微信关注" name="wechat">
									<wechat ref="wechat"></wechat>
								</el-tab-pane> -->
							</el-tabs>
						</div>
					</el-col>
					<el-col :span="24" v-else-if="activeName=='publish'">
						<div class="user_content">
							<div class="refresh-btn" @click="handleRefresh">
								<el-icon size="20">
									<Refresh />
								</el-icon>
							</div>
							<el-tabs v-model="activeName2" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane name="publish">
									<template #label>
										<span v-if="summary.excel_count">
											<el-badge :max="10000000" :value="summary.excel_count" class="item">
												<span>待完善</span>
											</el-badge>
										</span>
										<span v-else>
											<span>待完善</span>
										</span>
									</template>
									<publish ref="publish" :activeName="activeName2" v-on:pcsummary="pcsummary($event)"></publish>
								</el-tab-pane>
								<el-tab-pane name="manage">
									<template #label>
										<span v-if="summary.app_count">
											<el-badge :max="100000000" :value="summary.app_count" class="item">
												<span>定价上架</span>
											</el-badge>
										</span>
										<span v-else>
											<span>定价上架</span>
										</span>
									</template>
									<manage ref="manage" :activeName="activeName2" v-on:pcsummary="pcsummary($event)"></manage>
								</el-tab-pane>
								<!-- <el-tab-pane label="库存修改" name="save">
									<save ref="save"></save>
								</el-tab-pane> -->
								<!-- <el-tab-pane label="数据接口" name="proofread">
									<template #label>
										<span v-if="summary.total_num">
											<el-badge :max="100000000" :value="summary.total_num" class="item">
												<span>数据接口</span>
											</el-badge>
										</span>
										<span v-else>
											<span>数据接口</span>
										</span>
									</template>
									<proofread ref="proofread" v-on:pcsummary="pcsummary($event)"></proofread>
								</el-tab-pane> -->
							</el-tabs>
						</div>
					</el-col>
					<!-- <el-col :span="21" v-else-if="activeName=='TuoPublish'">
						<div class="user_content">
							<el-tabs v-model="activeName3" class="demo-tabs" @tab-click="handleClick">
								<el-tab-pane label="脱手库新增" name="TuoPublish">
									<TuoPublish></TuoPublish>
								</el-tab-pane>
								<el-tab-pane label="脱手库管理" name="TuoManage">
									<TuoManage></TuoManage>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col> -->
					<el-col :span="24" v-else-if="activeName=='tuoshou'">
						<div class="user_content">
							<el-tabs v-model="activeName4" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="信息优化" name="changestorage">
									<template #label>
										<span v-if="$globalData.to_edit_num">
											<el-badge :max="10000000" :value="$globalData.to_edit_num" class="item">
												<span>信息优化</span>
											</el-badge>
										</span>
										<span v-else>
											<span>信息优化</span>
										</span>
									</template>
									<changestorage ref="changestorage"></changestorage>
								</el-tab-pane>
								<el-tab-pane label="反馈列表" name="feedback">
									<template #label>
										<span v-if="$globalData.to_report_num">
											<el-badge :max="10000000" :value="$globalData.to_report_num" class="item">
												<span>反馈列表</span>
											</el-badge>
										</span>
										<span v-else>
											<span>反馈列表</span>
										</span>
									</template>
									<feedback ref="feedback"></feedback>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col>
					<el-col :span="24" v-else-if="activeName=='purchase'">
						<div class="user_content">
							<el-tabs v-model="activeName5" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="关于我们" name="purchase">
									<purchase ref="purchase"></purchase>
								</el-tab-pane>
								<el-tab-pane label="新手教程" name="newbieTutorial">
									<newbieTutorial ref="newbieTutorial"></newbieTutorial>
								</el-tab-pane>
								<el-tab-pane label="展示规则" name="displayRules">
									<displayRules ref="displayRules"></displayRules>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col>
					<el-col :span="24" v-else-if="activeName=='market'">
						<div class="user_content">
							<el-tabs v-model="activeName6" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="销售订单" name="market">
									<market></market>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col>
					<el-col :span="24" v-else-if="activeName=='shopping'">
						<div class="refresh-btn" @click="handleRefresh">
								<el-icon size="20">
									<Refresh />
								</el-icon>
							</div>
						<div class="user_content shopping">
							<el-tabs v-model="activeName7" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="购物车" name="shopping">
									
									<shopping ref="shopping"></shopping>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col>
					<el-col :span="24" v-else-if="activeName=='order'">
						<div class="user_content shopping">
							<el-tabs v-model="activeName8" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="订单详情" name="order">
									
									<order ref="order"></order>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col>
					<el-col :span="24" v-else-if="activeName=='orderList'">
						<div class="user_content shopping">
							<div class="refresh-btn" @click="handleRefreshOrder">
								<el-icon>
									<Refresh />
								</el-icon>
							</div>
							<el-tabs v-model="activeName9" class="demo-tabs" @tab-change="handleOrderTabChange">
						<el-tab-pane label="我的订单" name="all">
						</el-tab-pane>
						<el-tab-pane name="pending_confirmation">
								<template #label>
									<span v-if="orderNums.ddqx_num">
										<el-badge :max="10000000" :value="orderNums.ddqx_num" class="item">
											<span>等待确认</span>
										</el-badge>
									</span>
									<span v-else>
										<span>等待确认</span>
									</span>
								</template>
							</el-tab-pane>
							<el-tab-pane name="pending_payment">
								<template #label>
									<span v-if="orderNums.dzf_num">
										<el-badge :max="10000000" :value="orderNums.dzf_num" class="item">
											<span>待支付</span>
										</el-badge>
									</span>
									<span v-else>
										<span>待支付</span>
									</span>
								</template>
							</el-tab-pane>
							<el-tab-pane name="pending_shipment">
								<template #label>
									<span v-if="orderNums.dfh_num">
										<el-badge :max="10000000" :value="orderNums.dfh_num" class="item">
											<span>待发货</span>
										</el-badge>
									</span>
									<span v-else>
										<span>待发货</span>
									</span>
								</template>
							</el-tab-pane>
							<el-tab-pane name="pending_receipt">
								<template #label>
									<span v-if="orderNums.dsh_num">
										<el-badge :max="10000000" :value="orderNums.dsh_num" class="item">
											<span>待收货</span>
										</el-badge>
									</span>
									<span v-else>
										<span>待收货</span>
									</span>
								</template>
							</el-tab-pane>
						<el-tab-pane label="已完成" name="completed">
						</el-tab-pane>
						<el-tab-pane label="已取消" name="cancelled">
						</el-tab-pane>
					</el-tabs>
					<orderList ref="orderList" :status="activeName9" @refresh-order-nums="getOrderNums"></orderList>
						</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import '../../assets/user/index.css' //优化表格样式
import publish from './publish';
import proofread from './proofread';
import save from './save';
import TuoPublish from './TuoPublish';
import feedback from './feedback';
import tuoshou from './tuoshou';
import TuoManage from './TuoManage';
import userinfo from './userinfo';
import addr from './addr';
import helper from './helper';
import personal from './personal';
import manage from './manage';
import brand from './brand';
import wechat from './wechat';
import purchase from './purchase';
import market from './market';
import changestorage from './changestorage';
import newbieTutorial from './newbieTutorial';
import shopping from './shopping';
import displayRules from './displayRules';
import order from '../order/index';
import orderList from '../order/list';
import HeadIndex from '../public/HeadIndex';
import { House } from '@element-plus/icons-vue'
export default {
	name: 'user',
	components: {
		userinfo,displayRules,newbieTutorial,shopping,order,orderList,
		purchase,
		market,
		personal,
		addr,
		helper,
		wechat,
		brand,
		HeadIndex,
		publish,
		manage,
		TuoPublish,
		TuoManage,
		tuoshou,
		feedback,
		proofread,
		save,
		House,changestorage
	},
	data() {

		return {
			summary: {
				excel_count: 0,
				app_count: 0,
				total_num: 0,
			},
			orderNums: {
				ddqx_num: 0,
				dzf_num: 0,
				dfh_num: 0,
				dsh_num: 0,
			},
			activeName: 'userinfo',
			activeName1: 'userinfo',
			activeName2: 'publish',
			activeName3: 'TuoPublish',
			activeName4: 'changestorage',
			activeName5: 'purchase',
			activeName6: 'market',
			activeName7: 'shopping',
			activeName8: 'order',
			activeName9: 'all',
			data_tree: [{
					label: '个人中心',
					activeName: 'userinfo',
					children: [{
						label: '用户信息',
						info: 1,
						activeName: 'userinfo',
					}, {
						label: '品牌关注',
						info: 1,
						activeName: 'brand',
					}, {
						label: '微信关注',
						info: 1,
						activeName: 'wechat',
					}, ],
				},
				{
					label: '产品中心',
					activeName: 'publish',
					children: [{
							label: '库存预入',
							info: 1,
							activeName: 'publish',
						},
						{
							label: '库存详情',
							info: 1,
							activeName: 'manage',
						},
						{
							label: '库存修改',
							info: 1,
							activeName: 'save',
						},
						{
							label: '库存校对',
							info: 1,
							activeName: 'proofread',
						},
					],
				},
				/*{
					label: '脱手库中心',
					activeName: 'TuoPublish',
					children: [{
							label: '脱手库新增',
							activeName: 'TuoPublish',
							info: 1,
						},
						{
							label: '脱手库管理',
							activeName: 'TuoManage',
							info: 1,
						},
					],
				},*/
				{
					label: '关于我们',
					activeName: 'tuoshou',
					children: [{
							label: '脱手网',
							activeName: 'tuoshou',
							info: 1,
						},
						{
							label: '建议反馈',
							info: 1,
							activeName: 'feedback',
						},
					],
				}
				/*, {
									label: '退出登录',
									activeName: 'out',
									children: [],
								},*/
			],
			defaultProps: {
				children: 'children',
				label: 'label',
				class: 'cccc',
			},
		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {
		if (this.$route.query.type) {
			this.activeName = this.$route.query.type
		}
	},
	created() {
		this.activeName = this.$route.query.type
		this.pcsummary()
		this.getOrderNums()
	},
	watch: {
		'$route'(to, from) {
			console.log(to, from)
			// 这里可以访问to.query和from.query来比较查询参数的变化
			this.activeName = this.$route.query.type
			// 进行你需要的操作
		}
	},
	methods: {
		async pcsummary() {
			await this.$axios.post('/api/yunsys.storage/pcsummary', ).then(async (res) => {
					var res = res.data;
					this.summary = res.data

				})
				.catch(err => {

				})
		},
		async getOrderNums() {
			await this.$axios.post('/api/yunsys.Order/getordernums', ).then(async (res) => {
					var res = res.data;
					this.orderNums = res.data
				})
				.catch(err => {

				})
		},
		/*handleNodeClick(item) {
			if (item.activeName == "out") {



			}
			if (item.info == 1) { //点击切换
				var name = this.$refs.tree.getNode(item).parent.data.activeName
				switch (name) {
					case 'userinfo':
						this.activeName = 'userinfo'
						this.activeName1 = item.activeName
						break
					case 'publish':
						this.activeName = 'publish'
						this.activeName2 = item.activeName
						break
					case 'TuoPublish':
						this.activeName = 'TuoPublish'
						this.activeName3 = item.activeName
						break
					case 'tuoshou':
						this.activeName = 'tuoshou'
						this.activeName4 = item.activeName
						break
					default:
						return
				}
			}
			console.log(item.activeName, this.activeName2)
		},*/
		handleRefreshShopping(){
			this.$refs.shopping.search();
		},
		handleRefresh() {
			if (this.activeName2 == 'proofread' && this.activeName=='publish') {
				this.$refs[this.activeName2].search()
			}
			if (this.activeName2 == 'manage'  && this.activeName=='publish') {
				this.$refs[this.activeName2].grabble()
			}
			if (this.activeName2 == 'publish'  && this.activeName=='publish') {
				this.$refs[this.activeName2].grabble()
			}
			if (this.activeName7 == 'shopping'  && this.activeName=='shopping') {
				this.$refs[this.activeName7].grabble()
			}
			
		},
		handleClick() {
			if (this.activeName == "publish") {
				this.$nextTick(() => {
					this.$refs[this.activeName2].tableHeight_fun()
				})

				if (this.activeName2 == 'proofread') {
					this.$nextTick(() => {
						this.$refs[this.activeName2].search()
					})
				} else if (this.activeName2 == 'publish') {
					this.$nextTick(() => {
						this.$refs[this.activeName2].search()
					})
				} else if (this.activeName2 == 'manage') {
					this.$nextTick(() => {
						this.$refs[this.activeName2].search()
					})
				}
			} else if (this.activeName == "userinfo") {
				if (this.activeName1 == "helper") {
					ElMessageBox.confirm(
							'当前公测期，帮手可免费使用！',
							'提示', {
								confirmButtonText: '确认',
								type: 'warning',
							}
						)
						.then(() => {
							this.del_ajax(id)
						})
						.catch(() => {

						})
				}
				this.$nextTick(() => {
					this.$refs[this.activeName1].tableHeight_fun()
				})

			} else if (this.activeName == "tuoshou") {
				this.$nextTick(() => {
					this.$refs[this.activeName4].tableHeight_fun()
				})

			}else if (this.activeName == "purchase") {
				this.$nextTick(() => {
					this.$refs[this.activeName5].tableHeight_fun()
				})

			}

		},
		handleRefreshOrder(){
			this.$refs.orderList.grabble();
		},
		handleOrderTabChange() {
			this.$nextTick(() => {
				if (this.$refs.orderList) {
					this.$refs.orderList.tableHeight_fun();
				}
			})
		}
	}
}
</script>
<style lang="less" scoped>
:deep(.el-page-header__header) {

	line-height: 32px;
	margin-left: 30px;
}

:deep(.el-tree-node__expand-icon) {
	display: none;
}

:deep(.el-tree-node__content:hover) {
	background: #fff;
}

:deep(.el-tree-node.is-current>.el-tree-node__content) {
	color: #ff8a5c;
	background: #fff;
}

:deep(.el-tabs__item) {

	padding: 0 1.85rem;
}
:deep(.shopping .el-tabs__header){
    margin-bottom: 0px;
}
:deep(.el-tree-node:focus>.el-tree-node__content) {
	background-color: #fff !important;
}

/* 鼠标失去焦点时节点背景的颜色 */
:deep(.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content) {
	background: #fff;
}

:deep(.el-tree-node__content) {
	color: #999;
	padding-top: 10px;
}

:deep(.el-tabs__nav-scroll) {
	padding-left: 20px;
}

:deep(.el-page-header__header) {
	margin-left: 0px;
	line-height: 2.5rem;
}

:deep(.el-page-header__left) {
	margin-right: 0px;
}

:deep(.el-tabs__item:hover) {
	color: #ff8a5c;

}

:deep(.el-tabs__active-bar) {
	background-color: #ff8a5c;
	/* 选中标签下方的横线颜色 */
}

:deep(.el-tabs__item.is-active) {
	// background-color: #f56c6c; /* 选中标签的背景颜色 */
	//border-color: #f56c6c; /* 选中标签的边框颜色 */
	color: #ff8a5c;
	/* 选中标签的文字颜色 */
}

:deep(.el-input-group__append) {

	background: #ff8a5c;
}

.Page_heading {
	margin-top: 1.27rem;
}

.logo_m {
	height: 20px
}

.tabs-container {
	position: relative;
}

.refresh-btn {
	position: absolute;
	right: 10px;
	top: 30px;
	z-index: 1;
	cursor: pointer;
	color: #909399;
}

.refresh-btn:hover {
	color: #409EFF;
}
</style>